<template>
  <div class="routerview">
    <iframe class="iframe-slide" src="/slides_iframe_tc_01_secboot_signmodule"></iframe>
  </div>   
</template>


<script>
    export default {
        name: "slidestc_01_secboot_signmodule"
    }
</script>


<style scoped src="@/assets/css/globalcn.css">
</style>
